import React from 'react'
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import '../mysass.scss';

const Footer = () => {
  return (

<MDBFooter className='text-center' color='white' bgColor='dark'>
      <section className='d-flex justify-content-center justify-content-lg-between p-0 border-bottom'>

      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                Trip to KOSOVO
              </h6>
              {/* <p>
                Have a nice trip!
              </p> */}
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Products</h6>
              <p>
                <a>
                  HTML
                </a>
              </p>
              <p>
                <a>
                  CSS
                </a>
              </p>
              <p>
                <a>
                  JS
                </a>
              </p>
              <p>
                <a>
                  REACT
                </a>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
              <p>
                <MDBIcon className="me-2" />
                10000, Prishtinë, Kosovë
              </p>
              <p>
                <MDBIcon className="me-3" />
                info@example.com
              </p>
              <p>
                <MDBIcon  className="me-3" /> + 383 123 456
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2023 Copyright:
        <a className='text-reset fw-bold' href='https://react.com/'>
          ReactJS
        </a>
      </div>
    </MDBFooter>

  )
}

export default Footer